import React, {useState,useEffect} from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import {StatusOptions} from '../../Utils/api/DropdownfilterApi';
import { 
    Layout,
    Col, 
    Row,
    Button,
    Space,
    Input,
    Table,
    Select,
} from 'antd';

import {ProductOutlined } from '@ant-design/icons';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { useNavigate } from "react-router-dom"
import { capitalizeEachWord } from '../../Utils/Common';

const { Search } = Input;

const Member = () => {
  const navigate = useNavigate()
  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');

  const [filterConfig, setFilterConfig] = useState({
    member_id: '',
    term: '',
    status: '',
    page: 1,
  })

  const customSpinner = <ProductOutlined style={{ fontSize: 24, color: "#005E30"  }} spin />;


  const gender = [
      {
          value: '',
          label: 'All',
      },
      {
          value: 'male',
          label: 'Male',
      },
      {
          value: 'female',
          label: 'Female',
      },
  ]

    const defaultColumns = [
        {
            title: 'Customer ID',
            dataIndex: 'ar_cust_id',
            align: 'center',
            key: 'ar_cust_id',
        },
        {
            title: 'Member ID',
            dataIndex: 'member_no',
            align: 'center',
            key: 'member_no',
        },
        {
            title: 'Member',
            dataIndex: 'member_name',
            align: 'center',
            key: 'member_name',
        },
        ...(filterConfig?.dependents === 'spouse' || filterConfig?.dependents === '' ? [{
            title: 'Spouse',
            dataIndex: 'spouse_name',
            align: 'center',
            key: 'spouse_name',
        }] : []),
        ...(filterConfig?.dependents === 'children' || filterConfig?.dependents === '' ? [{
            title: 'Children',
            dataIndex: 'children',
            align: 'center',
            key: 'children',
            render: (_, record) => (
                <div>
                    {record?.childrens?.map((data, index) => (
                        <div key={index}>
                            - <strong>{data?.children_name}</strong>
                        </div>
                    ))}
                </div>
            ),
        }] : []),
    ];

  const columns = [
    {
      title: 'Customer ID',
      dataIndex: 'ar_cust_id',
      key: 'ar_cust_id',
      align: 'center',
      sorter: (a, b) => a.ar_cust_id?.localeCompare(b.ar_cust_id),
    },
    {
      title: 'Member ID',
      dataIndex: 'member_no',
      key: 'member_no',
      align: 'center',
      sorter: (a, b) => a.member_no?.localeCompare(b.member_no),
    },
    {
      title: 'Member Name',
      dataIndex: 'full_name',
      key: 'full_name',
      align: 'center',
      sorter: (a, b) => a.full_name?.localeCompare(b.full_name),
    
    },
    {
      title: 'Dependents',
      dataIndex: 'dependents',
      key: 'dependents', 
      align: 'center',   
      render: (_, record) => (
        <div>
          <div className='mb-2'>
            Spouse Name: <strong>{record?.dependents && record?.dependents[0]?.spouse_name}</strong>
          </div>
          <div>
            <div>Childrens:</div>
            {record?.dependents && record?.dependents[0]?.dependent_items?.map((data, index) => (
              <div key={index}>
                <strong>{data?.name}</strong>
              </div>
            ))}
          </div>
        </div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'latest_status',
      key: 'latest_status',
      align: 'center',
      render: (status) => status || '—',
    },
  ];

  async function fetchMemberData  () {
    setIsLoading(true)
    const response = await UseGetRequest("members/get_all", filterConfig);
    if (response?.data) {
      const member_data = response?.data?.members?.map((data) => ({
        ...data,
        full_name: capitalizeEachWord(data?.last_name) + " " + capitalizeEachWord(data?.first_name) + " " + capitalizeEachWord(data?.middle_name) + " " + capitalizeEachWord(data?.suffix)
      }))
      setMembers(member_data);
      setPageSize(response?.data?.size)
    } else {
      setMembers([])
      setPageSize('')
    }
    setIsLoading(false);
  }

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
    }));
  };

  const handleChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        term: e || '',
        page: 1,
      }
    ));
  };
    
  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          term: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  useEffect(() => {
    fetchMemberData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);
  
  return (
    <Layout className='page'>
      <Navbar navKey={'member'}/>
      <Layout className='content-container overflow-y'>
        <Row className='custom-padding'>
          <Col 
            xs={24} sm={24} md={12} lg={12} xl={12}
            className='header-container'
          >
            MEMBERS
          </Col>
          <Col 
            xs={24} sm={24} md={12} lg={12} xl={12}
            className='mt-2 responsive-tab-width' 
            align='end'
          >
            <Space className='responsive-inline'> 
              <Search
                placeholder="Search Member"
                size='medium'
                onSearch={(e)=>handleChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              />
              <Button 
                className='button-color responsive-header-btn' 
                onClick={() => navigate('/member/add')} 
                type="primary"
              >
                + Add Member
              </Button>
            </Space>
          </Col>
        </Row>
        <Row className='mb-4 member-status-filter-row'>
          <Space className='responsive-inline'>
            <Select
              placeholder="Select Status"
              aria-label="Filter members by status"
              value={filterConfig.status || undefined}
              onChange={(status) => setFilterConfig((prev) => ({
                ...prev,
                status: status || '',
                page: 1,
              }))}
              allowClear
              placement='bottomLeft'
              className='select-field responsive-header-input'
              options={StatusOptions()}
            />
          </Space>
        </Row>
        <Row>
          <Col span={24} className='page-content'>
            <Table 
              columns={columns} 
              dataSource={members} 
              // className='responsive-overflow-auto'
              loading={{
                indicator: customSpinner,
                spinning: isLoading,
              }}
              scroll={{ y: 525, x: 'max-content' }} 
              pagination={{
                defaultPageSize: 10,
                total: pageSize,
                current: filterConfig?.page,
                pageSize: filterConfig?.total_records_per_page,
              }}
              onChange={handleTableChange}
              onRow={(record, rowIndex) => {
                return {
                  className: 'cursor',
                  onClick: () => navigate('/member/profile', { state: { id: record.id } }),
                };
              }}
            />
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default Member
